import { useColorScheme } from '@mui/material'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { CheckCircle as CheckCircleIcon } from '@phosphor-icons/react/dist/ssr/CheckCircle'
import { WarningCircle as WarningCircleIcon } from '@phosphor-icons/react/dist/ssr/WarningCircle'
import type { NotificationProvider, OpenNotificationParams } from '@refinedev/core'
import { nanoid } from 'nanoid'
import { Slide, toast, ToastContainer } from 'react-toastify'

export function Toaster() {
	const { colorScheme } = useColorScheme()
	return (
		<ToastContainer
			theme={colorScheme}
			position="bottom-center"
			closeOnClick
			pauseOnHover
			pauseOnFocusLoss
			toastStyle={toastStyle}
			transition={Slide}
			closeButton={false}
			autoClose={4000}
			hideProgressBar
			stacked
			draggable={false}
		/>
	)
}

export const notificationProvider: NotificationProvider = {
	open: ({ type, message, description, key }: OpenNotificationParams) => {
		const toastId = key || nanoid(4)

		toast[type](<CustomToast message={toText(message)} description={toText(description)} />, {
			icon:
				type === 'success' ? (
					<CheckCircleIcon color="var(--mui-palette-success-main)" {...iconProps} />
				) : (
					<WarningCircleIcon color="var(--mui-palette-error-main)" {...iconProps} />
				),
			toastId,
		})
	},
	close: (key) => {
		toast.dismiss(key)
	},
}

function toText(value: unknown): string | undefined {
	return typeof value === 'string' || typeof value === 'number' ? String(value) : undefined
}

function CustomToast({ message, description }) {
	return (
		<Stack>
			<Typography variant="subtitle1" color="text.primary" fontSize={14} lineHeight="120%">
				{message}
			</Typography>
			{description ? (
				<Typography variant="subtitle2" color="text.primary" fontSize={13} lineHeight="120%">
					{description}
				</Typography>
			) : null}
		</Stack>
	)
}

const toastStyle = {
	borderRadius: 8,
	boxShadow: '0 4px 12px #0000001a',
	minHeight: 30,
	border: '1px solid var(--mui-palette-background-level2)',
}

const iconProps = {
	weight: 'fill',
	fontSize: 'var(--icon-fontSize-md)',
} as any

export { toast }
